/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import { Margin, Padding } from "@mui/icons-material";

function DataTableBodyCell({ noBorder, align, children, bgColor, textColor }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  return (
    <MDBox
      component="td"
      textAlign={align}
      py={1.5}
      px={3}
      sx={({ palette: { light }, typography: { size }, borders: { borderWidth } }) => ({
        fontSize: size.lg,
        borderBottom: noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`,
        ...(bgColor && { backgroundColor: bgColor }),
      })}
    >
      <MDBox
        display="block"
        width="100%"
        color={textColor || (darkMode ? "white" : "dark")}
        sx={{ padding: 0, verticalAlign: "middle", fontWeight: "bold", fontSize: "lg" }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
  bgColor: undefined,
  textColor: undefined,
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
  bgColor: PropTypes.string,
  textColor: PropTypes.string,
};

export default DataTableBodyCell;
